/**
 * Tests if current browser is a mobile browser
 */
export function isOnMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

/**
 * Tests if page is favorite
 */
export function isPageFavorite(favoritePageIds, pageId) {
  return favoritePageIds.indexOf(pageId) != -1;
}

/**
 * Uniqueness for arrays
 */
export function uniq(array) {
  return array.filter(function(x, i) {
    return array.indexOf(x) === i
  });
}

/**
 * Parses the given object. Checks if it has a `status` or `code` property.
 * When code is in 4XX range, it will show a generic error message in Flash.
 */
export function handleError(error) {
  var statusCode = parseInt(error.status || error.code);

  if(statusCode >= 400 && statusCode <= 499) {
    Flash.setMessage("error", "Your session was lost please log in again");
  }
}



// WEBPACK FOOTER //
// ./app/javascript/portal/documents/utils.js